import * as React from 'react';
import { FormattedMessage } from 'react-intl';

export class FormatMessageDiv extends React.PureComponent<any> {
  render() {
    return (
      <div className={this.props.className}>
        <FormattedMessage id={this.props.id} defaultMessage={this.props.defaultMessage} />
      </div>
    );
  }
}
